import {BaseModel} from '../base/BaseModel';

/**
 * @class PermissionRequestModel
 * @extends BaseModel
 *
 * @property {object} attributes
 * @property {string} attributes.requesteeEmail - Email of user who received permission request
 * @property {string} attributes.requesterId - Uuid of user who requests the permission
 * @property {string} attributes.requesteeId - Uuid of user who received the permission request
 * @property {string<PENDING|ACCEPTED|REJECTED|INVALID_COUNTRY>} attributes.status - status of permission request
 */
export class PermissionRequestModel extends BaseModel {

    initialize () {

        this.microservice = 'users';
        this.resource = 'permission-requests';
    }

    get idAttribute () {

        return 'uuid';
    }

    get defaults () {

        return {
            requesterId: undefined,
            requesteeId: undefined,
            status: undefined
        };
    }

    static get STATUS () {

        return {
            PENDING: 'PENDING',
            ACCEPTED: 'ACCEPTED',
            REJECTED: 'REJECTED',
            INVALID_COUNTRY: 'INVALID_COUNTRY'
        }
    }
}


// WEBPACK FOOTER //
// ./shared/model/users/PermissionRequestModel.js